import { memo } from 'react';
import { styled, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectComponentHeight } from 'store/entities/ui/selectors';

const DEFAULT_PAGINATOR_HEIGHT = 56;
const FAB_OFFSET = 40;

const FabWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'bottom',
})<{ bottom: number }>(({ theme, bottom }) => ({
  position: 'fixed',
  right: 16,
  bottom,
  zIndex: 10,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 48,
  height: 48,
  borderRadius: 24,
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  boxShadow: theme.shadows[6],
}));

type MobileSelectionCountFabProps = {
  count: number;
};

const MobileSelectionCountFabBase = ({ count }: MobileSelectionCountFabProps) => {
  const paginatorHeight = useSelector(selectComponentHeight('table-paginator')) ?? DEFAULT_PAGINATOR_HEIGHT;
  const bottom = paginatorHeight + FAB_OFFSET;

  if (count <= 0) {
    return null;
  }

  return (
    <FabWrapper bottom={bottom}>
      <Typography variant="subtitle1" component="span" fontWeight={700}>
        {count}
      </Typography>
    </FabWrapper>
  );
};

export const MobileSelectionCountFab = memo(MobileSelectionCountFabBase);
